import { ActionTypes } from 'src/app/models/api/playbooks/actions/actionTypes.enum';
import { MenuAction } from 'src/app/models/menuAction.model';
import { ViolationsSupportedActions } from './violationsSupportedActions';

export enum ViolationsActionsEnum {
  exempt = 'exempt',
  waive = 'waive',
}

export const menuByAction: { [violationAction: string]: MenuAction } = {
  [ViolationsSupportedActions.Exempt]: {
    name: ViolationsActionsEnum.exempt.toString(),
    displayNameLabel: 'violationActions.exempt',
    disabled: false,
  } as MenuAction,
  [ViolationsSupportedActions.Waive]: {
    name: ViolationsActionsEnum.waive.toString(),
    displayNameLabel: 'violationActions.waive',
    disabled: false,
  } as MenuAction,
};

export function getViolationStatusBulkActionType(status: ViolationsSupportedActions) {
  switch (status) {
    case ViolationsSupportedActions.Exempt:
      return ActionTypes.exemptViolation;
    case ViolationsSupportedActions.Waive:
      return ActionTypes.resetViolationStatus;
    default:
      throw new Error(`getViolationStatusBulkActionType: Missing support for ${status}`);
  }
}
